import { apiClient } from './client';

export const ctrbApi = apiClient.injectEndpoints({
    endpoints: (builder: any) => ({
        getCTRB: builder.query({
            query: ({ book_id }: { book_id: string }) => ({
                url: `/api/books/ctrb`,
                method: 'GET',
                params: { book_id }
            })
        }),
    }),
});

export const { useGetCTRBQuery } = ctrbApi;